import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="bg-white px-4 py-10 md:py-24 lg:px-8" id="pricing" data-id="element-83">
      <div className="mx-auto max-w-4xl text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="rounded-3xl bg-white p-10 shadow-2xl ring-1 ring-terracotta/10 md:p-16" data-id="element-85">
          <div className="mb-8 space-y-4" data-id="element-86">
            <p className="text-2xl font-medium text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-87">
              VALOR TOTAL: $148
            </p>
            <h2 className="font-serif text-5xl font-bold text-terracotta md:text-6xl" data-id="element-88">
              PRECIO HOY: $9.98
            </h2>
          </div>

          <a href="#mid-pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('mid-pricing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="group mb-8 inline-flex w-full max-w-lg items-center justify-center rounded-full bg-terracotta px-8 py-6 text-xl font-bold text-white shadow-xl transition-all hover:bg-[#d6761b] hover:shadow-2xl hover:-translate-y-1" data-id="element-89">
            ¡Obtén Acceso Instantáneo al Paquete de las 4 Estaciones por $9.98!
            <ArrowRight className="ml-2 h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-90" />
          </a>

          <div className="flex items-center justify-center space-x-2 text-sm font-medium text-sage" data-id="element-91">
            <ShieldCheck className="h-5 w-5" data-id="element-92" />
            <span data-id="element-93">Garantía de Devolución de 30 Días</span>
          </div>
        </motion.div>
      </div>
    </section>;
};